import axios from "axios";
// import store from "@/store/";
import { authService } from "@/auth";
// import { apiBaseUrl } from "@/environment/environment";
/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config = {
  baseURL: process.env.VUE_APP_CORE_API_HOST,
};

let add_slash = (original_url, base_url) => {
  console.log("Original URL", original_url);
  console.log("Base URL", base_url);
  let check_url;

  if (original_url && original_url.includes("https://")) check_url = original_url;
  else check_url = base_url || "";

  console.log("Check URL", check_url);
  if (!check_url.includes("-server.sensehawk.com")) return check_url;
  console.log("Sensehawk url");
  const [url, params] = original_url.split("?");

  if (!url.endsWith("/")) {
    console.log("Final URL", `${url}/${params ? "?" + params : ""}`);
    return `${url}/${params ? "?" + params : ""}`;
  }

  return original_url;
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const httpClient = axios.create(config);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currenlty it is just doing nothing but idea to to show the capability of axios and its interceptors
 * In future, interceptors can be created into separate files and consumed into multiple http clients
 * @param {*} config
 */
var cookies_organization;
const authInterceptor = (config) => {
  /** add auth token */
  if (!config.headers) config.headers = {};

  if (window.current_organization && window.current_organization.uid) {
    cookies_organization = window.current_organization;
  } else {
    cookies_organization = window.$cookies.get("user_organization");
    if (!cookies_organization) return;

    cookies_organization = JSON.parse(atob(cookies_organization));
  }

  config.headers["authorization"] = "jwt " + window.$cookies.get("access_token");
  if (!(config.url.includes("no_org") || config.url.includes("organization")) && cookies_organization)
    config.url += `${config.url.includes("?") ? "&" : "?"}organization=${cookies_organization.uid}`;

  config.url = add_slash(config.url, config.baseURL);

  return config;
};

const loggerInterceptor = (config) => {
  /** Add logging here */
  return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    console.log(error, error.response);
    if (error && error.response && error.response.status === 401 && originalRequest.url.includes("access-code-auth")) {
      window.location.href = location.origin + "/auth";
      return Promise.reject(error);
    }
    if (error && error.response && error.response.data.code === "OAUTH_21" && !originalRequest._retry) {
      originalRequest._retry = true;
      return authService.get_refresh_token().then((res) => {
        if (!res.data || !res.data.access_token) return;
        window.$cookies.set(
          "access_token",
          res.data.access_token,
          "1y",
          "/",
          window.location.hostname === "localhost" ? "localhost" : ".sensehawk.com"
        );
        originalRequest.headers["authorization"] = "jwt " + res.access_token;
        return axios(originalRequest);
      });
    } else return Promise.reject(error);
  }
);

export { httpClient };
